import { SetStateAction } from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from '@mui/material'

import { NavigationButton } from '../../navigation'
import { useUpdateMissingTranslations } from 'src/hooks'
import { ROUTES } from 'src/constants'

import { useStyles } from './styles'
import { ETranslationNs } from 'src/types'
import { HelperWrapper } from 'src/components/helper-wrapper'

interface IProps {
  languageCode: string
  translationDisabled: boolean
  selectedItemsIds?: string[]
  setSelectedItemsIds?: (value: SetStateAction<string[]>) => void
}

export const NavButtons = ({
  languageCode,
  translationDisabled,
  selectedItemsIds = [],
  setSelectedItemsIds,
}: IProps) => {
  const { mutate: updateTranslations, isLoading } = useUpdateMissingTranslations()
  const [t] = useTranslation(ETranslationNs.Navbar)
  const classes = useStyles()

  const handleUpdate = () => {
    updateTranslations({ languageCode: languageCode[0], selectedItemsIds })
    if (setSelectedItemsIds) {
      setSelectedItemsIds([])
    }
  }

  return (
    <div className={classes.buttonsWrapper}>
      <div style={{ height: 33 }}>
        <NavigationButton
          route={ROUTES.LANGUAGES}
          label={t('languages-header-title.v', { ns: ETranslationNs.Navbar })}
        />
      </div>
      <Button
        type="button"
        onClick={handleUpdate}
        variant="contained"
        disabled={isLoading || translationDisabled}
        color="secondary"
        className={classes.button}
      >
        <HelperWrapper t="translations-missing-translate-button" />
      </Button>
    </div>
  )
}
